<template>
  <div class="new-page-wrapper">
    <div class="new-page-content">
      <h1 class="title">ဖဲဂိမ္းအေၾကာင္း</h1>
      <div class="new-paragraph">
        <p>ရွမ္းကုိးမီးသည္ ျမန္မာႏုိင္ငံထဲတြင္အသစ္ဆံုး၊</p>
        <p>ျမန္မာလူငယ္အႀကိဳက္မ်ားဆံုး၊နာမည္အႀကီးဆံုးေသာ ဖဲဂိမ္းျဖစ္ပါ၏။</p>
        <p>ရွမ္းကိုးမီးသည္ျမန္မာ႐ိုးရာဖဲႏွင့္က်ားကစားစ၍ ျဖစ္ေပၚခဲ့ၿပီးျမန္မာလူငယ္အႀကိဳက္မ်ားဆံုးဂိမ္းျဖစ္၏။</p>
        <p>ရုိးရာဖဲရွမ္းကုိးမီးအျပင္ပုိကာ Texas ၊အန္စာတံုး၊ဖဲသံုးရြက္မ်ားစသည့္ေပ်ာ္စရာဖဲေဆာ့နည္းရွိေသးပါ။</p>
      </div>

      <div class="new-paragraph">
        <p>ဂိမ္းအမ်ဳိးအစားမ်ား</p>
        <p>ဤဂိမ္း၏အမ်ိဳးအစားသည္ အားလပ္ေပ်ာ္ရႊင္ျခင္းျဖစ္၍ ဂိမ္းမွာအားပါးတရေဆာ့ႏိုင္၍ ပ်င္းရိအပ်င္းေျဖႏုိင္၏။</p>
      </div>

      <div class="new-paragraph">
        <p>ဂိမ္းအထူးဗိုးနပ္</p>
        <p>ေနစဥ္ဂိမ္းဝင္၍မ်ားလဲမ်ားထူလဲထူေသာဗိုးနပ္ရႏိုင္သည္၊</p>
        <p>ဤတြင္မကပိုမ်ားမေတြးဆခဲ့ေသာလက္ေဆာင္ရွိမည္။</p>
        <p>လ်င္ျမန္စြာdownload၍ဗိုးနပ္ေတြလာရယူပါ။</p>
      </div>

      <div class="new-paragraph">
        <p>ခ်စ္ဖြယ္ရာစိတ္ဝင္စားဖြယ္ရာေကာင္းေသာစတစ္ကာမ်ား</p>
        <p>ဂိမ္းတြင္ခ်စ္ဖြယ္ရာစိတ္ဝင္စားဖြယ္ရာေကာင္းေသာစတစ္ကာမ်ား၍</p>
        <p>တံု႔ျပန္ျခင္းအဆက္မျပတ္ရွိသည္။မိတ္ေဆြေပါင္းသင္းလာဖြဲ႕ၾကပါ။</p>
      </div>

      <div class="new-paragraph">
        <p>ခ်စ္ၾကည့္ရင္းႏွီးေသာသူငယ္ခ်င္းႏွင့္အတူေပါင္းသင္းဆက္ဆံစကားေျပာျခင္း</p>
        <p>ဂိမ္းတြင္သူငယ္ခ်င္းေတြထပ္ထည့္ႏိုင္သည္၊မိတ္ေဆြကိုဖိတ္ေခၚလာကစားၾကပါ။</p>
        <p>မည္သူအစစ္ပိုကာဆရာႀကီးျဖစ္သနည္း။</p>
      </div>

      <div class="new-paragraph">
        <p>၂၀၁၉ႏွစ္တြင္ျမန္မာႏိုင္ငံလူအႀကိဳက္မ်ားဆံုးဖဲႏွင့္က်ားဂမ္းျဖစ္၏၊</p>
        <p>ေသာင္းေက်ာ္ကစားသမားမ်ားတစ္ခ်ိန္တည္းမွာ အြန္လိုင္းသည္၊</p>
        <p>မည္သူအစစ္ဖဲကစားဆရာႀကီးျဖစ္တတ္သနည္း။</p>
        <p>သင္လာကစားလွ်င္နာမည္စာရင္းတြင္ပထမထိပ္ဆံုးျဖစ္လိမ္</p>
        <p>ဂိမ္းကိုလ်င္ျမန္စြာdownloadၿပီး သူငယ္ခ်င္းေတြကိုစိန္ေခၚျခင္းေစာင့္ေနၾကသည္။</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less">
@import "~src/styles/Normalize";
@import "~src/styles/index";
@import "~src/styles/new";
</style>